import { useEffect, useState } from 'react';
import { Building2, Headphones, Mail, MapPin, Phone, Route, Target, UsersRound } from 'lucide-react';
import { PageHeader } from '../components/ui';
import { api } from '../lib/api';

export function AboutPage() { return <><section className="section bg-mist"><div className="container"><PageHeader eyebrow="Hakkımızda" title="Lojistiği herkes için daha anlaşılır kılıyoruz." text="EHES, taşımacılık talebini dijitalleştirerek rota, zaman ve fiyat belirsizliğini ortadan kaldırmak için tasarlandı."/></div></section><section className="section"><div className="container grid gap-8 lg:grid-cols-2"><div className="rounded-4xl bg-navy p-9 text-white md:p-12"><Target className="text-coral" size={38}/><h2 className="mt-8 text-3xl font-bold">Misyonumuz</h2><p className="mt-4 leading-8 text-slate-300">Müşterilerin taşımacılık ihtiyaçlarını hızlıca tanımlayabildiği, rotayı şeffaf biçimde görebildiği ve güncel fiyatlarla karar verebildiği güvenilir bir altyapı sunmak.</p></div><div className="grid gap-5 sm:grid-cols-2"><div className="card p-7"><Route className="text-teal"/><h3 className="mt-5 font-bold text-navy">Doğru rota</h3><p className="mt-2 text-sm leading-6 text-slate-600">Gerçek yol verisine dayalı planlama.</p></div><div className="card p-7"><UsersRound className="text-teal"/><h3 className="mt-5 font-bold text-navy">Müşteri odağı</h3><p className="mt-2 text-sm leading-6 text-slate-600">Sade, hızlı ve erişilebilir deneyim.</p></div><div className="card p-7 sm:col-span-2"><Building2 className="text-teal"/><h3 className="mt-5 font-bold text-navy">Büyümeye hazır altyapı</h3><p className="mt-2 text-sm leading-6 text-slate-600">Taşıyıcı, şoför, canlı takip ve ödeme modülleriyle genişleyebilen mimari.</p></div></div></div></section></>; }

type PublicSettings = {
  companyName: string;
  supportEmail: string | null;
  supportPhone: string | null;
  address: string | null;
};

export function ContactPage() {
  const [settings, setSettings] = useState<PublicSettings | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    api<{ settings: PublicSettings }>('/system/settings')
      .then(({ settings: nextSettings }) => {
        if (active) setSettings(nextSettings);
      })
      .catch(() => {
        if (active) setFailed(true);
      });
    return () => {
      active = false;
    };
  }, []);

  const items = [
    {
      icon: Phone,
      title: 'Telefon',
      value: settings?.supportPhone,
      href: settings?.supportPhone ? `tel:${settings.supportPhone.replace(/[^+\d]/g, '')}` : undefined,
    },
    {
      icon: Mail,
      title: 'E-posta',
      value: settings?.supportEmail,
      href: settings?.supportEmail ? `mailto:${settings.supportEmail}` : undefined,
    },
    { icon: MapPin, title: 'Adres', value: settings?.address, href: undefined },
  ];

  return <>
    <section className="section bg-mist"><div className="container"><PageHeader eyebrow="İletişim" title="Yükünüzü birlikte planlayalım." text="Sorularınız, hesap işlemleriniz ve operasyon talepleriniz için EHES destek ekibine ulaşın."/></div></section>
    <section className="section"><div className="container grid gap-8 lg:grid-cols-[.9fr_1.1fr]">
      <div className="space-y-4">
        {items.map(({ icon: Icon, title, value, href }) => {
          const content = <><span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-teal/10 text-teal"><Icon size={20}/></span><div><p className="font-semibold text-navy">{title}</p><p className="mt-1 break-words text-sm text-slate-500">{value ?? (settings || failed ? 'Henüz yayınlanmadı' : 'Yükleniyor…')}</p></div></>;
          return href
            ? <a className="card flex gap-4 p-5 transition hover:-translate-y-0.5 hover:shadow-lg" href={href} key={title}>{content}</a>
            : <div className="card flex gap-4 p-5" key={title}>{content}</div>;
        })}
      </div>
      <div className="rounded-3xl bg-navy p-7 text-white md:p-10">
        <Headphones className="text-coral" size={34}/>
        <p className="mt-5 text-2xl font-bold">{settings?.companyName ?? 'EHES Lojistik'} desteği</p>
        <p className="mt-3 max-w-xl text-sm leading-7 text-slate-300">Hesap, teklif, araç, sefer ve konum takibiyle ilgili destek talepleriniz için yayınlanan iletişim kanallarından bize ulaşabilirsiniz. Talebinizde varsa teklif veya sefer numarasını belirtin; parolanızı ya da doğrulama bilginizi paylaşmayın.</p>
        {settings?.supportEmail
          ? <a className="mt-7 inline-flex min-h-11 items-center justify-center gap-2 rounded-xl bg-coral px-5 py-2.5 text-sm font-semibold text-white shadow-lg shadow-coral/20 transition hover:bg-[#e6420b]" href={`mailto:${settings.supportEmail}?subject=${encodeURIComponent('EHES Lojistik Destek Talebi')}`}><Mail size={17}/> Destek E-postası Gönder</a>
          : <p className="mt-7 rounded-2xl bg-white/10 p-4 text-sm text-slate-200">Destek e-postası henüz yayınlanmadı. Lütfen telefon veya adres bilgisi mevcutsa bu kanalları kullanın.</p>}
      </div>
    </div></section>
  </>;
}
